import * as moment from 'moment';

export class PagedResultDtoOfUserListDto {
    totalCount: number;
    items: UserListDto[];

    setPagedResult(pagedResult: any) {
        this.totalCount = pagedResult.totalCount;
        this.items = pagedResult.items || [];
    }
}

export class UserListDto {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    phoneNumber: string;
    profilePictureId: string;
    isEmailConfirmed: boolean;
    roles: UserListRoleDto[];
    groups: UserListGroupDto[];
    permissions: string[];
    lastLoginTime: moment.Moment;
    isActive: boolean | undefined;
    creationTime: moment.Moment;
    id: number;
    isLinkedUser: boolean;

    setUserList(userList: any) {
        this.name = userList.name || '';
        this.surname = userList.surname || '';
        this.userName = userList.userName || '';
        this.emailAddress = userList.emailAddress || '';
        this.phoneNumber = userList.phoneNumber;
        this.profilePictureId = userList.profilePictureId;
        this.isEmailConfirmed = userList.isEmailConfirmed;
        this.roles = userList.roles || [];
        this.groups = userList.groups || [];
        this.permissions = userList.permissions || [];
        this.lastLoginTime = userList.lastLoginTime;
        this.isActive = userList.isActive;
        this.creationTime = userList.creationTime;
        this.id = userList.id;
        this.isLinkedUser=userList.isLinkedUser;
    }
}

export class GetUserForEditOutput {
    profilePictureId: string;
    user: UserEditDto;
    roles: UserRoleDto[];
    allOrganizationUnits: OrganizationUnitDto[];
    memberedOrganizationUnits: string[];
}

export class CreateOrUpdateUserInput {
    user: UserEditDto;
    assignedRoleNames: string[];
    sendWelcomeEmail: boolean;
    setRandomPassword: boolean;
    organizationUnits: number[];
}

export class UserListRoleDto {
    roleId: number;
    roleName: string;
}

export class UserListGroupDto {
    id: number;
    name: string;
}

export class  UserEditDto {
    id: number;
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    phoneNumber: string;
    password: string;
    isActive: boolean;
    shouldChangePasswordOnNextLogin: boolean;
    isTwoFactorEnabled: boolean;
    isLockoutEnabled: boolean;
}

export class UserRoleDto {
    roleId: number;
    roleName: string;
    roleDisplayName: string;
    isAssigned: boolean;
}

export class OrganizationUnitDto {
    parentId: number;
    code: string;
    displayName: string;
    memberCount: number;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class UserDto {
  id: number;
  name: string;
  surname: string;
  userName: string;
  emailAddress: string;
}

export class EntityDtoOfInt64 {
    id: number;
}

export class PasswordComplexityResponseModelData {
  result: PasswordComplexityResponseModel;
}

export class PasswordComplexityResponseModel {
  setting: PasswordComplexitySettings;
}

export class PasswordComplexitySettings {
  requireDigit: boolean;
  requireLowercase: boolean;
  requireNonAlphanumeric: boolean;
  requireUppercase: boolean;
  requiredLength: number;
}

export class UserListFilter {
    tenantId: number;
    filter: string;
    sorting: string;
    skipCount: number;
    maxResultCount: number;
    isOnlyNormalUsers:boolean;
}

export class ResendInvitationDto {
    tenantId: number;
    userId: number;
    userName: string;
}
